// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"80ea93d1","977":"a568149e"}[chunkId] + ".chunk.js";
};